import { Step1, Step2, Step3, Step4 } from '@/components/entities/order/OrderAddSteps'
import { ProductManager } from '@/components/entities/product/ProductManager'
import { StepBack } from '@/components/lib/StepBack'
import useOrderAdd from '@/hooks/use-order-add'
import { BookingSlotType } from '@/types/BookingSlotType'
import { ProductType } from '@/types/ProductType'
import { tempColor } from '@/utils/Functions'
import { InfoIcon } from 'lucide-react'
import React from 'react'
import { Alert, Button, Card, Col, Form, Image, Row, Spinner, Table } from 'react-bootstrap'


interface OrderCreate {
  ageRestriction?: number | string | null
  barcode?: string
  bookingSlot: string
  _bookingSlot?: BookingSlotType
  client?: {
    email: string
    firstname: string
    lastname: string
    phone: string
  }
  hold?: number
  products: ProductType[]
  receiveCode?: string
  multiOrderCode?: string
  totalSlot?: number
}


export const OrderAdd: React.FC = () => {

  const {
    //states
    companies,
    companySelected,
    onSubmitLoading,
    orders,
    setOrders,
    client,
    stepCreation,
    setStepCreation,
    register,
    handleSubmit,
    reset,
    isDesktop,
    //functions
    handleCompanySelected,
    handleClearState,
    handleSaveNbSlot,
    handleSumbitNbSlot,
    handlePrepareOrder,
    handleSetProducts,
    handleRemoveProductLine,
    handleSaveOrder,
  } = useOrderAdd()


  /**
   * Components Desktop View
   */

  const slotQtyDesktop = () => (
    <>
    <Table striped hover responsive>
      <thead>
        <tr>
          <th>Machine</th>
          <th className=''>Zone et dimensions </th>
          <th className='text-center'>Casiers disponibles</th>
          <th className='text-center'>Qté de casier souhaitée</th>
        </tr>
      </thead>
      <tbody>
        {companySelected?.bookingSlots?.map((booking: BookingSlotType) => (
          <tr key={booking.id}>
            <td>
              {booking?.slot?.temperatureZone?.locker?.location}
              <br />
              {booking?.slot?.temperatureZone?.locker?.shortLocation}
            </td>
            <td className=''>
              {' '}
              {booking?.slot?.temperatureZone?.name}
              <br />H {booking?.slot?.height} x L {booking?.slot?.width} x P{' '}
              {booking?.slot?.depth} cm
            </td>
            <td className='text-center'>{booking.available}</td>
            <td className='text-end card'>
              <input
                type='text'
                className=' form-control text-center bg-white'
                placeholder='0'
                onChange={(e) => handleSaveNbSlot(Number(e.currentTarget.value), booking)}
                />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
     <div className='buttons text-end'>
              <Button variant='secondary' className='me-3' onClick={handleClearState}>
                Annuler
              </Button>
              <Button type='submit' variant='dark' onClick={handleSumbitNbSlot}>
                Valider
              </Button>
            </div>
                </>
  )

  const productsOrderDesktop = () => (
    <Row>
      <Col className='col-xl-8 col-lg-10 col-md-12 mx-auto'>
        <Row>
          <Col className='col-4'>
            <Card>
              <Card.Body>
                <div className='text-center'>
                  <Image
                    src={'/img/avatar-default.png'}
                    alt='Image'
                    className='img-fluid my-3'
                    width={80}
                  />
                  <p>
                    {client?.firstname + ' ' + client?.lastname}
                    <br />
                    {client?.phone}
                    <br />
                    {client?.email}
                  </p>
                </div>
              </Card.Body>
            </Card>
            <div className='buttons text-end mt-4'>
              <Button
                variant='secondary'
                className='me-3 w-100'
                onClick={() => {
                  reset()
                  setOrders([])
                  setStepCreation(1)
                }}
              >
                Annuler la commande
              </Button>
              <Button
                type='submit'
                variant='success'
                className='w-100 mt-3'
                onClick={handleSaveOrder}
              >
                {onSubmitLoading ? <Spinner size={'sm'} /> : 'Valider la commande'}
              </Button>
            </div>
          </Col>
          <Col>
            <Alert variant='info'>
              <Row>
                <Col className='col-1 text-center'>
                  <InfoIcon className='pt-1' size={35} />
                </Col>
                <Col>
                  Renseigner les produits n'est pas une obligation, sauf si la commande
                  contient de l'alcool, auquel cas il est important et obligatoire de le
                  déclarer.
                </Col>
              </Row>
            </Alert>
            {orders?.map((order: OrderCreate, index: number) => (
              <Card key={index} className='mb-3'>
                <Card.Header className='bg-card-header'>
                  <h5 className='mb-0'>Casier {index + 1}</h5>
                  <small>
                    Destination :{' '}
                    {order?._bookingSlot?.slot?.temperatureZone?.locker?.location}
                    {' - '}
                    {order?._bookingSlot?.slot?.temperatureZone?.locker?.shortLocation}
                    <br />
                    Zone de température : {order?._bookingSlot?.slot?.temperatureZone?.name}
                  </small>
                </Card.Header>
                <Card.Body>
                  <ProductManager
                    key={index}
                    initialProducts={order.products}
                    setProducts={(products) => handleSetProducts(index, products)}
                    removeProduct={(productIndex) =>
                      handleRemoveProductLine(index, productIndex)
                    }
                  />
                </Card.Body>
              </Card>
            ))}
          </Col>
        </Row>
      </Col>
    </Row>
  )
  
  /**
   * Components Mobile View
  */
 
 const slotQtyMobile = () => (
   <>
     {companySelected?.bookingSlots?.map((booking: BookingSlotType) => (
       <Card
         key={booking.id}
         className='d-flex flex-column align-items-center justify-content-between mb-4 py-3'
         style={{ height: '160px' }}
       >
         <div>{booking?.slot?.temperatureZone?.locker?.shortLocation}</div>
         <div>
           <strong className={`text-${tempColor(booking?.slot?.temperatureZone?.name)}`}>
             {booking?.slot?.temperatureZone?.name} :{' '}
           </strong>
           <span>{booking.available} casiers dispo</span>
         </div>
         <div>
           <Form.Control
             type='text'
             placeholder='0'
             className='rounded text-center bg-white'
             onChange={(e) => handleSaveNbSlot(Number(e.currentTarget.value), booking)}
           />
         </div>
       </Card>
     ))}
     <div className='fab text-end'>
       <Button variant='secondary' className='me-3' onClick={handleClearState}>
         Annuler
       </Button>
       <Button type='submit' variant='dark' onClick={handleSumbitNbSlot}>
         Valider
       </Button>
     </div>
   </>
 )

  const productsOrderMobile = () => (
    <div>
      <Alert variant='info'>
        <Row className='gap-2'>
          <Col className='col-1 text-center'>
            <InfoIcon className='pt-1' size={35} />
          </Col>
          <Col className='font-65'>
            Renseigner les produits n'est pas une obligation, sauf si la commande contient de
            l'alcool, auquel cas il est important et obligatoire de le déclarer.
          </Col>
        </Row>
      </Alert>
      <Card>
        <Card.Body>
          <div className='text-center'>
            <Image
              src={'/img/avatar-default.png'}
              alt='Image'
              className='img-fluid mb-3'
              width={50}
            />
            <p>
              {client?.firstname + ' ' + client?.lastname}
              <br />
              {client?.phone}
              <br />
              {client?.email}
            </p>
          </div>
        </Card.Body>
      </Card>
      {orders?.map((order: OrderCreate, index: number) => (
        <Card key={index} className='mb-3'>
          <Card.Header className='bg-card-header'>
            <h5 className='mb-0'>Casier {index + 1}</h5>
            <small>
              Destination :{' '}
              {/* {order?._bookingSlot?.slot?.temperatureZone?.locker?.location}
                          {' - '} */}
              {order?._bookingSlot?.slot?.temperatureZone?.locker?.shortLocation}
              <br />
              Zone : {order?._bookingSlot?.slot?.temperatureZone?.name}
            </small>
          </Card.Header>
          <Card.Body>
            <ProductManager
              key={index}
              initialProducts={order.products}
              setProducts={(products) => handleSetProducts(index, products)}
              removeProduct={(productIndex) => handleRemoveProductLine(index, productIndex)}
            />
          </Card.Body>
        </Card>
      ))}
      <div className='buttons text-end mt-4 '>
        <Button
          variant='secondary'
          className='me-3 w-100'
          onClick={() => {
            reset()
            setOrders([])
            setStepCreation(1)
          }}
        >
          Annuler la commande
        </Button>
        <Button
          type='submit'
          variant='success'
          className='w-100 mt-3'
          onClick={handleSaveOrder}
        >
          {onSubmitLoading ? <Spinner size={'sm'} /> : 'Valider la commande'}
        </Button>
      </div>
    </div>
  )

  const step1Props = { companies, handleCompanySelected }
  const step2Props = { isDesktop, slotQtyDesktop, slotQtyMobile }
  const step3Props = {
   handleSubmit,
   handlePrepareOrder,
   register,
   reset,
   setOrders,
   setStepCreation,
 }
  const step4Props = { isDesktop, productsOrderDesktop, productsOrderMobile }


  /* Render
   *******************************************************************************************/
  return (
    <>
      <Row>
        <Col>
          <StepBack stepCreation={stepCreation} setStepCreation={setStepCreation} />
        </Col>
      </Row>
      {/* Step 1 */}
      {stepCreation === 1 && <Step1 step1Props={step1Props} />}
      {/* Step 2 */}
      {stepCreation === 2 && <Step2 step2Props={step2Props} />}
      {/* Step 3 */}
      {stepCreation === 3 && <Step3 step3Props={step3Props} />}
      {/* Step 4 */}
      {stepCreation === 4 && <Step4 step4Props={step4Props} />}
    </>
  )
}
